<template>
  <div class="alice-toolbar">
    <div class="alice-toolbar__search">
      <Icon name="search" :size="18" />
      <input
        ref="input"
        :value="modelValue"
        type="text"
        placeholder="Search projects, clients, methods…"
        class="alice-toolbar__input"
        @input="$emit('update:modelValue', $event.target.value)"
      />
      <span class="alice-toolbar__count"
        >{{ count }} result{{ count !== 1 ? "s" : "" }}</span
      >
    </div>

    <button class="alice-toolbar__btn" @click="toggleSort">
      <Icon name="sort" :size="18" />
      <span>{{ sort === "recent" ? "Most recent" : "A → Z" }}</span>
      <Icon name="chevron-down" :size="14" />
    </button>

    <div class="alice-toolbar__view">
      <button
        class="alice-toolbar__btn alice-toolbar__btn--icon"
        :class="{ 'is-active': view === 'rows' }"
        @click="$emit('update:view', 'rows')"
        title="Row view"
      >
        <Icon name="rows" :size="18" />
      </button>
      <button
        class="alice-toolbar__btn alice-toolbar__btn--icon"
        :class="{ 'is-active': view === 'grid' }"
        @click="$emit('update:view', 'grid')"
        title="Grid view"
      >
        <Icon name="grid" :size="18" />
      </button>
    </div>

    <button
      v-if="canCreate"
      class="alice-toolbar__new"
      @click="$emit('new-project')"
    >
      <span class="alice-toolbar__new-accent" aria-hidden="true" />
      <span class="alice-toolbar__new-content">
        <Icon name="plus" :size="16" />
        <span>New project</span>
      </span>
    </button>
  </div>
  <!-- TODO: facet filters (status / owner / client) -->
</template>

<script>
import Icon from "./Icon.vue";

export default {
  name: "AliceToolbar",
  components: { Icon },
  props: {
    modelValue: { type: String, default: "" },
    sort: { type: String, default: "recent" },
    view: { type: String, default: "rows" },
    count: { type: Number, default: 0 },
    canCreate: { type: Boolean, default: true },
  },
  emits: ["update:modelValue", "update:sort", "update:view", "new-project"],
  methods: {
    toggleSort() {
      this.$emit("update:sort", this.sort === "recent" ? "alpha" : "recent");
    },
  },
};
</script>

<style scoped>
.alice-toolbar {
  display: flex;
  align-items: stretch;
  gap: 0;
  border-bottom: 1px solid var(--border-hairline);
  background: var(--vp-white);
  height: 56px;
  flex-shrink: 0;
}

.alice-toolbar__search {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 20px;
  border-right: 1px solid var(--border-hairline);
  color: var(--vp-black);
}
.alice-toolbar__input {
  flex: 1;
  height: 100%;
  border: none;
  outline: none;
  background: transparent;
  font-family: var(--font-body);
  font-size: 16px;
  color: var(--vp-black);
}
.alice-toolbar__input::placeholder {
  color: var(--fg-3);
}
.alice-toolbar__count {
  font-family: var(--font-ui);
  font-size: 12px;
  color: var(--fg-3);
  white-space: nowrap;
}

.alice-toolbar__btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 18px;
  background: transparent;
  border: none;
  border-right: 1px solid var(--border-hairline);
  cursor: pointer;
  color: var(--vp-black);
  font-family: var(--font-ui);
  font-size: 13px;
  font-weight: 600;
  border-radius: 0;
  transition: background var(--dur-fast) var(--ease-hover),
    transform var(--dur-press) var(--ease-out);
}
.alice-toolbar__btn:hover {
  background: var(--bg-muted);
}
.alice-toolbar__btn:active {
  transform: scale(0.97);
}
.alice-toolbar__btn.is-active {
  background: var(--bg-muted);
}
.alice-toolbar__btn--icon {
  padding: 0 14px;
  border-right: none;
}

.alice-toolbar__view {
  display: flex;
  border-right: 1px solid var(--border-hairline);
}

.alice-toolbar__new {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 24px;
  background: var(--vp-black);
  color: var(--vp-white);
  border: none;
  cursor: pointer;
  font-family: var(--font-ui);
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  overflow: hidden;
  border-radius: 0;
  transition: transform var(--dur-press) var(--ease-out);
}
.alice-toolbar__new:active {
  transform: scale(0.98);
}
.alice-toolbar__new-accent {
  position: absolute;
  inset: 0;
  background: var(--accent-100);
  transform: translateX(-101%);
  transition: transform var(--dur-base) var(--ease-out);
  z-index: 0;
}
.alice-toolbar__new:hover .alice-toolbar__new-accent {
  transform: translateX(0);
}
.alice-toolbar__new-content {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  gap: 10px;
  color: inherit;
}

@media (max-width: 1279px) {
  .alice-toolbar__btn:not(.alice-toolbar__btn--icon) span:nth-child(2) {
    display: none;
  }
}
</style>
